module.exports = __webpack_public_path__ + "img/WeChat_code.6ae0452d.png";